import { createIcon } from "@illa-design/icon"

export const TriangleTop = createIcon({
  title: "TriangleIconTop",
  viewBox: "0 0 8 4",
  d: "M8 0H0L3.29289 3.29289C3.68342 3.68342 4.31658 3.68342 4.70711 3.29289L8 0Z",
})

export const TriangleBottom = createIcon({
  title: "TriangleIconBottom",
  viewBox: "0 0 8 4",
  d: "M8 4H0L3.29289 0.707107C3.68342 0.316583 4.31658 0.316583 4.70711 0.707107L8 4Z",
})

export const TriangleLeft = createIcon({
  title: "TriangleIconLeft",
  viewBox: "0 0 4 8",
  d: "M0 8V0L3.29289 3.29289C3.68342 3.68342 3.68342 4.31658 3.29289 4.70711L0 8Z",
})

export const TriangleRight = createIcon({
  title: "TriangleIconRight",
  viewBox: "0 0 4 8",
  d: "M4.00098 8V0L0.707366 3.29281C0.316726 3.68335 0.316726 4.31665 0.707366 4.70719L4.00098 8Z",
})
